export { SimpleTableComponent } from './simple-table.component';
export { SimpleTableRowDirective } from './simple-table-row.directive';
export { SimpleTableConfig } from './simple-table.config';
export * from './interface';
export { AdSimpleTableModule } from './simple-table.module';
